import { Service } from '@roc/client-portal-shared/services';

const url = {
  APPRAISAL_PAYMENT_STATUS:
    '/nportal/rest/pub/payments/getAppraisalPaymentStatus?entityId=',
  TAMARISK_DOCUMENT: '/nportal/rest/pub/payments/getTamariskDocusign?entityId=',
  CDA_DOCUMENT: '/nportal/rest/pub/payments/getCDADocusign?entity=',
  GENERATE_CDA_DOCUMENT: '/nportal/rest/pub/signing/generateCDADisclosureDocument',
  ARR_CDA_DOCUMENT: '/nportal/rest/pub/payments/getARRDocusign?entity=',
  APPRAISAL_RECERTIFICATION_DOCUMENT:
    '/nportal/rest/pub/payments/getAppraisalRecertificationDocusign?entity=',
  PERSIST_BORROWER_DATA: '/nportal/rest/pub/payments/persistBorrowerData',
  INTERNAL_VALUATION_DOCUMENT:
    '/nportal/rest/pub/payments/getInternalValuationDocusign',
  VALIDATE_INTERNAL_VALUATION_LINK:
    '/nportal/rest/pub/payments/validateInternalValuationLink',
  GENERATE_FAST_TRACK: '/nportal/rest/pub/signing/generateFastTrackDocument',
  GENERATE_APPRAISAL_PAYMENT:
    '/nportal/rest/pub/signing/generateAppraisalPaymentDocument',
  FETCH_AMC_PAYMENT_LINK: '/api/v1/loan/internalValuation/getAmcPaymentLink',
};

export class LoanTermsService extends Service {
  getAppraisalPaymentStatus(entityId: string, type: string) {
    return this.get(`${url.APPRAISAL_PAYMENT_STATUS}${entityId}&type=${type}`);
  }

  getTamariskDocusign(request) {
    return this.post(`${url.TAMARISK_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  getArrDocusign(request) {
    return this.post(`${url.ARR_CDA_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  getAppraisalRecertificationDocusign(request) {
    return this.post(
      `${url.APPRAISAL_RECERTIFICATION_DOCUMENT}`,
      request,
      undefined,
      {
        responseType: 'text',
      }
    );
  }

  getCDADocusign(request) {
    return this.post(`${url.CDA_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  generateCDADisclosureDocument(request) {
    return this.post(
      `${url.GENERATE_CDA_DOCUMENT}`,
      request);
  }

  /** Resolves with the loan id the signed internal valuation payment link grants access to. */
  validateInternalValuationLink(token: string) {
    return this.get(url.VALIDATE_INTERNAL_VALUATION_LINK, { token });
  }

  /** The request carries the signed link token; the backend derives the loan from it. */
  getInternalValuationDocusign(request) {
    return this.post(`${url.INTERNAL_VALUATION_DOCUMENT}`, request, undefined, {
      responseType: 'text',
    });
  }

  persistBorrowerData(
    id: string,
    cardholderName: string,
    cardholderEmail: string,
    tamariskFlowType: string
  ) {
    const body = {
      id,
      cardholderName,
      cardholderEmail,
      tamariskFlowType,
    };

    return this.post(`${url.PERSIST_BORROWER_DATA}`, body);
  }

  persistBorrowerDataForFastrack(
    id: string,
    cardholderName: string,
    cardholderEmail: string,
    flowType: string
  ) {
    const body = {
      id,
      cardholderName,
      cardholderEmail,
      tamariskFlowType: flowType,
    };

    return this.post(`${url.PERSIST_BORROWER_DATA}`, body);
  }

  generateFastTrackDocument(data) {
    return this.post(url.GENERATE_FAST_TRACK, data);
  }

  generateAppraisalPaymentDocument(data) {
    return this.post(url.GENERATE_APPRAISAL_PAYMENT, data);
  }

  getAmcPayment = (loanId: any) => {
    return this.get(`${url.FETCH_AMC_PAYMENT_LINK}?loanId=${loanId}`);
  };
}
